








import Vue from 'vue';
import {
  Component,
} from 'vue-property-decorator';
import NotificationsSnackbar from '@/components/snackbar/NotificationsSnackbar.vue';

import Default from './layout/Default.vue';
import Auth from './layout/Auth.vue';

@Component({
  components: {
    Default,
    Auth,
    NotificationsSnackbar,
  },
})
export default class App extends Vue {
  get layout() {
    return this.$route.meta.layout || 'Default';
  }
}
